'use strict';

var crypto = require('./crypto');

var now = require('./now');

var env = require('./env');

var tags = require('./tags');

var validate = require('./validate');

var metrics = require('./metrics');

var plugins = require('../../plugins/browser');

var startupLog = require('./startup-log');

var exporter = require('./exporter');

var Loader = require('./loader');

var Scope = require('../../scope/zone');

var platform = {
  _config: {},
  // TODO: determine what should be the name/version/engine
  name: function name() {},
  version: function version() {},
  engine: function engine() {},
  crypto: crypto,
  now: now,
  env: env,
  tags: tags,
  validate: validate,
  service: function service() {
    return 'browser';
  },
  appVersion: function appVersion() {
    return null;
  },
  metrics: metrics,
  plugins: plugins,
  startupLog: startupLog,
  hostname: function hostname() {},
  // TODO: add hostname
  on: function on() {},
  // TODO: add event listener
  off: function off() {},
  // TODO: add event listener
  Loader: Loader,
  getScope: function getScope() {
    return Scope;
  },
  exporter: exporter,
  profiler: function profiler() {
    return {
      start: function start() {},
      stop: function stop() {}
    };
  }
};
module.exports = platform;